import { FOfferType } from '../../../../../../../../../packages/JsonQuery';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectObjectTypeFilter } from 'shared/selectors/advancedFilters';

export const SaleObjectTypeContainer = () => {
  const { value, options } = useSelector(selectObjectTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleObjectTypeChange = useCallback(
    (nextValue: FOfferType) => {
      onChange({ action: 'setOfferType', arguments: [nextValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label="Тип объекта">
      <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleObjectTypeChange} />
    </AdvancedFilterRow>
  );
};
